import { AuthContext, useUser } from "../auth/authHooks";
import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import useLocalStorage from "./useLocalStorage";
import { AUTH_RETURN_PATH } from "@jnctn/webcore/storage/localStorageKeys";
import { Path } from "history";
import { createPath } from "history";

// When a user is expired, and shouldSignin returns true, the user will be
// redirected to the idp server, and redirected back to the route they were on
export function useAutoSigninOnExpired(
  shouldSignin: () => boolean = () => true,
  customLocation?: Path
) {
  const { signinRedirect } = useContext(AuthContext);
  const user = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const [, setPath] = useLocalStorage(AUTH_RETURN_PATH, "/");
  useEffect(() => {
    if (
      user &&
      user.expired &&
      (shouldSignin === undefined || shouldSignin())
    ) {
      setPath(createPath(customLocation || location));
      signinRedirect();
    }
  }, [
    user,
    navigate,
    location,
    customLocation,
    setPath,
    signinRedirect,
    shouldSignin,
  ]);
}
